import type { FeedView } from '../lib/feed';
import { Banner } from './Panel';

/** Explains any non-normal feed condition. Silent only for fresh live data in an open market. */
export function FeedBanner({ view }: { view: FeedView }) {
  if (view.state === 'live') {
    if (view.marketOpen === false) {
      return (
        <Banner tone="info" title="Market closed">
          Spot gold is outside trading hours. Live prices resume when the market reopens.
        </Banner>
      );
    }
    return null;
  }
  if (view.state === 'replay') {
    return (
      <Banner tone="info" title="REPLAY DATA" icon="↺">
        {view.message}
      </Banner>
    );
  }
  if (view.state === 'fallback') {
    return <Banner tone="fallback" title={view.title}>{view.message}</Banner>;
  }
  const tone = view.state === 'delayed' || view.state === 'initial' || view.state === 'awaiting_data' ? 'warn' : 'danger';
  return (
    <Banner tone={tone} title={view.title}>
      {view.message}
    </Banner>
  );
}
